export const AGENT_PROFILE_EMBED_HEIGHT_MESSAGE = "egpt-agent-profile-embed-height" as const;
export const AGENT_PROFILE_EMBED_OPEN_WIDGET_MESSAGE =
  "egpt-agent-profile-open-widget" as const;

export type AgentProfileEmbedHeightMessage = {
  type: typeof AGENT_PROFILE_EMBED_HEIGHT_MESSAGE;
  height: number;
  projectId?: string;
};

export type AgentProfileEmbedOpenWidgetMessage = {
  type: typeof AGENT_PROFILE_EMBED_OPEN_WIDGET_MESSAGE;
  projectId: string;
  tab?: string;
};

export function isAgentProfileEmbedOpenWidgetMessage(
  data: unknown,
): data is AgentProfileEmbedOpenWidgetMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as AgentProfileEmbedOpenWidgetMessage).type ===
      AGENT_PROFILE_EMBED_OPEN_WIDGET_MESSAGE &&
    typeof (data as AgentProfileEmbedOpenWidgetMessage).projectId === "string"
  );
}

export function isAgentProfileEmbedHeightMessage(
  data: unknown,
): data is AgentProfileEmbedHeightMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as AgentProfileEmbedHeightMessage).type === AGENT_PROFILE_EMBED_HEIGHT_MESSAGE &&
    typeof (data as AgentProfileEmbedHeightMessage).height === "number"
  );
}

/** Notify parent iframe host of document height (builder / hire preview). */
export function reportAgentProfileEmbedHeight(projectId?: string): void {
  if (typeof window === "undefined" || window.self === window.top) return;

  const height = Math.max(
    document.documentElement.scrollHeight,
    document.body.scrollHeight,
    document.documentElement.offsetHeight,
  );

  window.parent.postMessage(
    { type: AGENT_PROFILE_EMBED_HEIGHT_MESSAGE, height, projectId },
    window.location.origin,
  );
}

/** Ask parent host (Post AI Job) to open widget as overlay instead of in-iframe sidebar. */
export function postAgentProfileEmbedOpenWidget(
  projectId: string,
  tab?: string,
): void {
  if (typeof window === "undefined" || window.self === window.top) return;
  window.parent.postMessage(
    { type: AGENT_PROFILE_EMBED_OPEN_WIDGET_MESSAGE, projectId, tab },
    window.location.origin,
  );
}

/** Open the production w.js embed (hire builder iframe / agent profile embed). */
export function openProductionEasyGptWidget(tab = "aiChat", message = ""): void {
  if (typeof window === "undefined") return;

  const tryOpen = (attempt: number) => {
    const win = window as Window & {
      easyGPTOpen?: (opts?: { tab?: string; message?: string }) => void;
    };

    if (typeof win.easyGPTOpen === "function") {
      win.easyGPTOpen({ tab, message });
      return;
    }

    if (attempt < 12) {
      window.setTimeout(() => tryOpen(attempt + 1), 250);
      return;
    }

    document.getElementById("easygpt-launcher")?.click();
  };

  tryOpen(0);
}

/** Remove document-level w.js chrome so it cannot cover onboard sidebars. */
export function closeProductionEasyGptWidget(): void {
  if (typeof window === "undefined") return;
  for (const id of [
    "easygpt-iframe-container",
    "easygpt-widget-container",
    "easygpt-launcher",
  ]) {
    document.getElementById(id)?.remove();
  }
  document
    .querySelectorAll('script[src*="/w.js"], script[src*="/w-v2.js"]')
    .forEach((node) => node.remove());
  const win = window as Window & { easyGPTOpen?: unknown };
  try {
    delete win.easyGPTOpen;
  } catch {
    win.easyGPTOpen = undefined;
  }
}
